/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilitypublic1Inputs */

const zh_share_visibilitypublic1 = /** @type {(inputs: Share_Visibilitypublic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开`)
};

const en_share_visibilitypublic1 = /** @type {(inputs: Share_Visibilitypublic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const es_share_visibilitypublic1 = /** @type {(inputs: Share_Visibilitypublic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público`)
};

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Share_Visibilitypublic1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilitypublic1 = /** @type {((inputs?: Share_Visibilitypublic1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilitypublic1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilitypublic1(inputs)
	if (locale === "en") return en_share_visibilitypublic1(inputs)
	return es_share_visibilitypublic1(inputs)
});
export { share_visibilitypublic1 as "share_visibilityPublic" }